<template>
    <div class="box">
        <div class="contaner-title"><span>财务管理</span> <span>/ 资金提现</span></div>
        <div class="hr"></div>
        <Tabs>
        <TabPane label="支付宝提现" class="tab">
        <div class="contaner">
           <div><img src="../../assets/user_icon.png" alt=""> <span>提现申请</span></div>
             <div>
                 <Form :label-width="200">
                    <FormItem label="用户名:">
                        {{UserInfo.Realname}}
                    </FormItem>
                    <FormItem label="可提现金额:"  >
                        {{UserInfo.Amount}}
                    </FormItem>
                     <!-- <FormItem label="提现金额:" prop="AmountNumAlipay" >
                        <Input style="width:474px;" v-model="AmountNumAlipay" placeholder="请输入提现金额"></Input>
                    </FormItem> -->
                    <div class="tip-row">
                        <Icon style="color:#aa6708;margin-right:5px;" type="ios-alert-outline" />提现申请提交后，将会先扣除相应账户金额，预计1-2个工作日到达提现账户，如有疑问请联系18969025950
                    </div>
                    <FormItem label="支付宝账号:"  >
                        {{UserInfo.Alipay}}
                    </FormItem>
                    <FormItem label="支付宝实名:" >
                        {{UserInfo.AlipayRealname}}
                    </FormItem>
                    <div class="complete-tip-row">
                        请先完善<a href="javascript:;" @click="goToUserInfo">用户资料</a>
                    </div>
                    <!-- <div class="btn-sub">
                        <Button type="success" size="large" @click="handleSubmitAlipay('formValidateAlipay')">申请提现</Button>
                    </div> -->
                </Form>
            </div>
        </div>
        </TabPane>
        <TabPane label="银行卡提现" class="tab">
        <div class="contaner">
           <div><img src="../../assets/user_icon.png" alt=""> <span>提现申请</span></div>
             <div>
                 <Form :label-width="200">
                      <FormItem label="用户名:">
                            {{UserInfo.Realname}}
                      </FormItem>
                    <FormItem label="可提现金额:">
                        {{UserInfo.Amount}}
                    </FormItem>
                     <!-- <FormItem label="提现金额:" prop="AmountNumBank" >
                        <Input style="width:474px;" v-model="AmountNumBank"  placeholder="请输入提现金额"></Input>
                    </FormItem> -->
                    <div class="tip-row">
                        <Icon style="color:#aa6708;margin-right:5px;" type="ios-alert-outline" />提现申请提交后，将会先扣除相应账户金额，预计1-2个工作日到达提现账户，如有疑问请联系18969025950
                    </div>
                    <FormItem label="银行卡号:"  >
                        {{UserInfo.Bank.Account}}
                    </FormItem>
                    <FormItem label="户名:"   >
                        {{UserInfo.Bank.Username}}
                    </FormItem>
                    <FormItem label="开户行:"  >
                        {{UserInfo.Bank.Name}}
                    </FormItem>
                    <div class="complete-tip-row">
                        请先完善<a href="javascript:;" @click="goToUserInfo">用户资料</a>
                    </div>
                    <!-- <div class="btn-sub">
                        <Button type="success" size="large" @click="handleSubmitBank('formValidateBank')">申请提现</Button>
                    </div> -->
                </Form>
            </div>
        </div>
        </TabPane>
        </Tabs>
        <Table  :row-class-name="rowClassName" :columns="columns" :data="projectList"></Table>
        <!-- <Page :total="Count" @on-change="changePage" /> -->
    </div>
</template>
<script>
import OssUplad from "../../components/OssUpload";
export default {
       components: {
         OssUplad
        },
    data(){
        return{
            UserInfo:{Bank:{}},
            AmountNumAlipay: '',//支付宝提现金额
            AmountNumBank: '',//银行提现金额
            projectList:[],//项目列表
            Count: 0,//项目总数
            Page:1,//当前页
            PageSize:10,//每页数量
            columns: [
                    {
                        title: '项目名',
                        key: 'Name',
                        align:'center',
                    },
                    {
                        title: '创建日期',
                        key: 'AddTime',
                        align:'center',
                        render:(h,params)=>{
                            var text='';
                            if(params.row.AddTime){
                                text= new Date(params.row.AddTime).format("yyyy-MM-dd");
                            } else {
                                text = '-';
                            }
                            return h('span',{

                             },text)
                        }
                    },
                    {
                        title: '完结日期',
                        key: 'CompleteTime',
                        align:'center',
                        render:(h,params)=>{
                            var text='';
                            if(params.row.AddTime){
                                text= new Date(params.row.AddTime).format("yyyy-MM-dd");
                            } else {
                                text = '-';
                            }
                            return h('span',{

                             },text)
                        }
                    },
                    {
                        title: '可提现金额',
                        key: 'AmountSettled',
                         align:'center',
                    },
                    {
                        title: '操作',
                         align:'center',
                        render:(h,params)=>{
                            return h('div',[
                                    h('Button',{
                                        props: {
                                            type: 'success',
                                            size: 'small'
                                            },
                                            on:{
                                                "click":()=>{
                                                    this.handleSubmitAlipay(params.row)
                                                },
                                            },
                                            style:{
                                                'margin-right':'3px',
                                            }
                                    },'申请支付宝提现'),
                                    h('Button',{
                                        props: {
                                            type: 'primary',
                                            size: 'small'
                                            },
                                            on:{
                                                "click":()=>{
                                                    this.handleSubmitAlipay(params.row)
                                                }
                                        }
                                    },'申请银行卡提现'),
                                ])
                        }
                    },
                ],
        }
    },
    mounted(){
        this.init();
        Date.prototype.format = function(fmt) { 
            var o = { 
                "M+" : this.getMonth()+1,                 //月份 
                "d+" : this.getDate(),                    //日 
                "h+" : this.getHours(),                   //小时 
                "m+" : this.getMinutes(),                 //分 
                "s+" : this.getSeconds(),                 //秒 
                "q+" : Math.floor((this.getMonth()+3)/3), //季度 
                "S"  : this.getMilliseconds()             //毫秒 
            }; 
            if(/(y+)/.test(fmt)) {
                fmt=fmt.replace(RegExp.$1, (this.getFullYear()+"").substr(4 - RegExp.$1.length)); 
            }
            for(var k in o) {
                if(new RegExp("("+ k +")").test(fmt)){
                    fmt = fmt.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));
                }
            }
            return fmt; 
        }
    },
    methods:{
        //初始化数据
        init() {
            let UserInfo = JSON.parse(this.$getLS('AdminInfo'));
            let params = {
                ID : UserInfo.ID,
            }
            this.$post('api/manage.PersonCenter/getMemberInfo', params).then(res=>{
                if (res.code == 1) {
                    this.UserInfo = res.data
                    this.getProjectList();
                 }
            });
        },
        //跳转到第N页
        changePage(val){
            this.Page=val;
            this.getProjectList();
        },
        //获取项目列表
        getProjectList() {
            var params={
                page: this.Page,
                pageSize: this.PageSize,
                MemberID: this.UserInfo.ID,
            }
            this.$post('api/manage.ProjectManage/getProjectListWithdrawal', params).then(res=>{
                if (res.code == 1) {
                    this.projectList = res.data.data;
                    this.Count = res.data.all_num;
                }
            });
        },
        //处理申请支付宝提现
        handleSubmitAlipay (row) {
            if (this.UserInfo.Alipay == null || this.UserInfo.Alipay == '' || this.UserInfo.AlipayRealname == null || this.UserInfo.AlipayRealname == '') {
                this.$Message.error('请先去用户资料页面完善支付宝信息！');return;
            }
            // if (this.AmountNumAlipay == '') {
            //     this.$Message.error('提现金额不能为空');return;
            // }
            var param={
                ID:this.UserInfo.ID,
                ProjectID: row.ID,
                // Amount:this.AmountNumAlipay,
                Amount:row.AmountSettled,
                Type:'Alipay',
            }
            this.$post('api/manage.PersonCenter/ApplyCash',param).then(res=>{
                if(res.code==1){
                    this.$Message.success(res.msg);
                    this.init();
                }else{
                    this.$Message.error(res.msg);
                }
            })
        },
        //处理申请银行卡提现
        handleSubmitBank (row) {
            if (this.UserInfo.Bank.Account == null || this.UserInfo.Bank.Account == '' 
            || this.UserInfo.Bank.Username == null || this.UserInfo.Bank.Username == '' 
            || this.UserInfo.Bank.Name == null || this.UserInfo.Bank.Name == '') {
                this.$Message.error('请先去用户资料页面完善银行卡信息！');return;
            }
            // if (this.AmountNumBank == '') {
            //     this.$Message.error('提现金额不能为空');return;
            // }
            var param={
                ID:this.UserInfo.ID,
                ProjectID: row.ID,
                // Amount:this.AmountNumBank,
                Amount:row.AmountSettled,
                Type:'Bank'
            }
            this.$post('api/manage.PersonCenter/ApplyCash',param).then(res=>{
                if(res.code==1){
                    this.$Message.success(res.msg);
                    this.AmountNumAlipay = '';
                    this.AmountNumBank = '';
                    this.init();
                }else{
                    this.$Message.error(res.msg);
                }
            })
        },
        //前往用户资料页面
        goToUserInfo() {
            this.$router.push({path:'UserInfo'});
        },
        rowClassName (row, index) {
            if ((index%2) === 1) {
                return 'demo-table-info-row';
            } 
            return '';
        }
    }
}
</script>
<style lang="less" scoped>
.box{
    padding:30px;
    box-sizing: border-box;
    // height : 100%;
    .contaner{
        background-color: #fff;
        margin-top: 30px;
        box-shadow: 0px 3px 5px rgb(200, 204, 209);
        height : 100%;
        >div:nth-of-type(1){
            overflow: hidden;
            padding:25px;
            border-bottom: 1px solid #E6E9EB;
            img{
                float: left;
            }
            span{
                float: left;
                font-size: 22px;
                color:#334659;
                margin-left: 10px;
            }
        }
        >div:nth-of-type(2){
            padding:30px 0px;
            box-sizing: border-box;
            .btn-sub{
             border-top: 1px solid #eee;
            padding-top: 20px; 
            text-align: center;
            }
            
        }
        .uploadImg{
            >div{
                position: relative;
                padding-right:10px;
                img{
                    width: 154px;
                    height: 94px;
                    margin-right: 10px;
                }
                i{
                    position: absolute;
                    right:0px;
                    top:-10px;
                    font-size: 20px;
                    cursor: pointer;
                }

            }
        }
        .file-list{
         
            width: 500px;
            li{
                   overflow: hidden;
                   cursor: pointer;
            span{
                float: left;
            }
            i{
                float: right;
                cursor: pointer;
            }
            }
           
        }
    }
}
.tip-row{
    margin-left:120px;
    margin-bottom: 30px;
    color: #aa6708;
    background-color: #f0f3f6;
    width: 715px;
    padding:15px;
    border-radius: 5px;
}
.complete-tip-row{
    text-align:center;
    margin-bottom:30px;
}
</style>






// WEBPACK FOOTER //
// src/view/AccountManage/CashWithApply.vue